import React from 'react';

function TOS() {
  return (
    <div className="container mx-auto py-20 px-4">
      <h1 className="text-4xl font-bold text-indigo-700 mb-6">Terms of Service</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        Welcome to YourBrand. By using our website and services, you agree to comply with and be bound by the following terms and conditions.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">1. Acceptance of Terms</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        By accessing or using our website, you agree to be bound by these terms and conditions. If you do not agree with any part of the terms, you must stop using our site.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">2. Modifications to Terms</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        We reserve the right to change or modify these terms at any time. Any changes will be effective immediately upon posting on this page. Your continued use of the site after such changes constitutes acceptance of the new terms.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">3. User Responsibilities</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        You agree to use the website in accordance with all applicable laws and regulations. You may not use our website to engage in any illegal activities or violate the rights of others.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">4. Intellectual Property</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        All content on this site, including text, images, logos, and trademarks, are the property of YourBrand and protected by copyright laws. You may not reproduce, distribute, or create derivative works without prior written consent.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">5. Limitation of Liability</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        YourBrand will not be held liable for any damages resulting from the use or inability to use our website or services. This includes, but is not limited to, direct, indirect, incidental, and consequential damages.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">6. Governing Law</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        These terms are governed by the laws of [Your Country/State]. Any legal disputes arising from these terms shall be resolved in the courts of [Your Jurisdiction].
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">7. Contact Information</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        If you have any questions regarding these terms, please contact us at info@yourbrand.com.
      </p>
    </div>
  );
}

export default TOS;

